import { render, staticRenderFns } from "./FormPriorInspection.vue?vue&type=template&id=38ed8f26"
import script from "./FormPriorInspection.vue?vue&type=script&lang=js"
export * from "./FormPriorInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports